/* eslint-disable react/no-unescaped-entities */
import React from 'react'

import { Search3D } from '@cinch/oxd-components/icons/src'
import SVG from '@cinch/oxd-components/svg/src'

import * as styles from './empty-results.module.css'

interface EmptyResultProps {
  title?: string
  body?: string
  searchTerms?: string[]
}

const EmptyResults: React.FC<EmptyResultProps> = ({ title, body, searchTerms = [] }) => {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.vector}>
        <SVG children={Search3D} size={136} />
      </div>
      <p className={styles.body}>{body}</p>
      {!!searchTerms.length && (
        <p className={styles.exampleSearch}>
          e.g.
          {searchTerms.map((term, idx) => (
            <span key={idx} className={styles.exampleSearchTerm}>
              "{<span className={styles.quoted}>{term}</span>}"
            </span>
          ))}
        </p>
      )}
    </div>
  )
}

EmptyResults.defaultProps = {
  title: 'Sorry, no results found',
  body: 'No cars found with your search, please try something else',
  searchTerms: ['Cars under 60,000 miles', 'Black hatchback'],
}

export default EmptyResults
